import { render, staticRenderFns } from "./edit-clinic.vue?vue&type=template&id=54cf3724&scoped=true&"
import script from "./edit-clinic.vue?vue&type=script&lang=js&"
export * from "./edit-clinic.vue?vue&type=script&lang=js&"
import style0 from "./edit-clinic.vue?vue&type=style&index=0&id=54cf3724&scoped=true&lang=css&"
import style1 from "./edit-clinic.vue?vue&type=style&index=1&id=54cf3724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf3724",
  null
  
)

export default component.exports